"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiToggleButton = getMuiToggleButton;
exports.getMuiToggleButtonGroup = getMuiToggleButtonGroup;
function getMuiToggleButtonGroup(palette) {
  return {
    styleOverrides: {
      root: {
        '.MuiToggleButton-root': {
          '&.Mui-selected': {
            '&:has(.MuiSvgIcon-root)': {
              '&:hover': {
                backgroundColor: palette.common.black,
                border: "solid 1px ".concat(palette.grey[800])
              },
              '.MuiSvgIcon-root': {
                backgroundColor: palette.grey[800],
                color: palette.common.white
              },
              backgroundColor: palette.grey[800],
              border: "solid 1px ".concat(palette.grey[800])
            },
            '&:not(:has(.MuiSvgIcon-root))': {
              '&:hover': {
                backgroundColor: palette.grey[200],
                border: 'solid 1px #C4C4C4'
              },
              backgroundColor: palette.grey[200],
              border: 'solid 1px #C4C4C4'
            }
          },
          '&:has(.MuiSvgIcon-root)': {
            '&:hover': {
              backgroundColor: 'transparent',
              border: "solid 1px ".concat(palette.grey[600])
            },
            '.MuiSvgIcon-root': {
              backgroundColor: palette.common.white,
              color: palette.grey[600],
              height: '24px',
              width: '24px'
            },
            border: "solid 1px ".concat(palette.grey[600]),
            height: '28px',
            padding: 0,
            width: '28px'
          },
          '&:hover': {
            backgroundColor: palette.grey[100],
            border: 'solid 1px #C4C4C4'
          },
          border: 'solid 1px #C4C4C4',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '22px',
          padding: '5px 12px',
          textTransform: 'inherit'
        }
      }
    }
  };
}
function getMuiToggleButton(palette) {
  return {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          '&:hover': {
            backgroundColor: palette.common.white
          },
          '> *': {
            backgroundColor: palette.grey[600]
          },
          backgroundColor: palette.common.white,
          border: "solid 1px ".concat(palette.info.main)
        },
        '&:hover': {
          backgroundColor: palette.common.white
        },
        '> *': {
          backgroundColor: palette.grey[300]
        },
        border: 'none',
        color: palette.common.black,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 22,
        padding: 0
      }
    }
  };
}